export default "__VITE_ASSET__B4YLf8zW__"